export default {
    data() {
        return {
            driverList: [
                {id: '', name: ''},
            ],
        };
    },
    methods: {
        getDriverList(type) {
            this.driverList = [];
            axios.get(`/driver-list?type=${type}`)
                .then(({data}) => {
                    Object.entries(data.data).forEach(entry => {
                        const [key, value] = entry;
                        if (value.type === 2) {
                                this.driverList.push({
                                    id: value.id,
                                    name: value.name,
                                });
                        }
                    });
                })
                .catch(e => {
                    console.error('Error fetching driver list:', e);
                });
        },
    },
};
